import Button from '@material-ui/core/Button';
import React, { Component } from 'react';
import { BarLoader } from 'react-spinners';

export default class FormSubmitButton extends Component {
  render() {
    return (
      <Button
        onClick={this.props.onClick}
        disabled={this.props.loading || this.props.disabled}
        className={`${this.props.className} ${
          this.props.disabled ? 'disabled__form__button' : ''
        }`}
        variant={this.props.variant || 'contained'}
        color="primary"
      >
        {this.props.loading ? (
          <BarLoader
            color="#fff"
            width={this.props.loaderWidth || 100}
            height={4}
          />
        ) : (
          <span>{this.props.children}</span>
        )}
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormElements/FormSubmitButton.jsx